export const NO_REPORTING_CUSTOMERS = [
  'welcome2sit.elearnio.net',
  'pierre-fabre.elearnio.net',
];
